var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFire = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3325 3.57164C32.3325 0.00907653 27.7446 -1.33362 25.7238 1.61971C7.185 28.7176 33.53 29.9376 33.53 43.1101C33.53 48.4435 29.1726 52.759 23.8228 52.6886C18.5583 52.6212 14.37 48.2324 14.37 42.9679V30.1681C14.37 26.9199 10.4078 25.3437 8.16845 27.6983C4.16131 31.9075 0 39.1179 0 47.9001C0 63.7475 12.8926 76.6401 28.74 76.6401C44.5874 76.6401 57.48 63.7475 57.48 47.9001C57.48 22.4098 32.3325 19.0104 32.3325 3.57164Z",
    fill: "#B61E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fire.d5f4a19765cdf1061f1183822349833b.svg";